<template>
  <div>
    <pet-details v-for="(pet, index) in pets"
      :key="pet.id"
      :pet-id="pet.id"
      :index="index"
      @deletePet="removePet(pet.id)"/>
    <a v-if="canAddMorePets" @click="addPet" class="w-100 text-center mb-5" style="cursor: pointer !important">Add additional pet?</a>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import { GeneralRegistrationSettingsCacheMixin } from '@/mixins/GeneralRegistration/GeneralRegistrationSettingsCacheMixin'
import PetDetails from './PetDetails.vue'

export default {
  name: 'NewPets',
  mixins: [StatusEmitterMixin, GeneralRegistrationSettingsCacheMixin],
  computed: {
    ...mapState('ClientRegistrationUpload', [
      'pets'
    ]),
    validated () {
      return this.pets.every(p => !!p.isValid)
    },
    canAddMorePets () {
      return this.pets.length < this.petsLimit
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'addPet'
    ]),
    ...mapMutations('ClientRegistrationUpload', [
      'removePet'
    ])
  },
  created () {
    if (this.pets.length === 0) {
      this.addPet()
    }
  },
  components: {
    'pet-details': PetDetails
  }
}
</script>
